var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBymBom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12h24v4H6zM10.707 12L7 15.707M16.707 12L13 15.707M22.707 12L19 15.707M28.707 12L25 15.707"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M2 20h4v6H2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M1.5 25.5h29v1h-29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7a2 2 0 012 2v11h0-4V9a2 2 0 012-2z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymBom);
export default __webpack_public_path__ + "static/media/BYM_Bom.3722b250.svg";
export { ForwardRef as ReactComponent };